import { render, staticRenderFns } from "./MyHead.vue?vue&type=template&id=19032eec&scoped=true&"
import script from "./MyHead.vue?vue&type=script&lang=js&"
export * from "./MyHead.vue?vue&type=script&lang=js&"
import style0 from "./MyHead.vue?vue&type=style&index=0&id=19032eec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19032eec",
  null
  
)

export default component.exports